import {EditFormQuestionDocument, FormQuestionInput} from "generated/graphql";
import {useMutation} from "@apollo/client";

export const useEditFormQuestion = () => {
  const [mutate] = useMutation(EditFormQuestionDocument);

  return (question: FormQuestionInput) => mutate({ variables: { input: { question } } });
}